import {motion} from 'framer-motion';
import {useSelector} from 'react-redux';
import Selector from '../../../selectors/modules/lucky_wheel/spinner';

export default () => {
    const { sectors, wheel } = useSelector(Selector);

    const getTransition = () => {
        switch (wheel.status) {
            case 'spin':
                return {
                    duration: 5,
                    ease: [0.08, 0.72, 0.16, 1],
                };

            case 'spin-finale':
                return {
                    duration: 0.6,
                    ease: [0.22, 1, 0.36, 1],
                };

            default:
                return {
                    duration: 0,
                };
        }
    };

    return (
        <motion.div
            className="wheel-spinner"
            animate={{
                rotate: wheel.rotate,
            }}
            transition={getTransition()}
        >
            {sectors.map((sector, key) => {
                return (
                    <div className="sector" key={key}>
                        <div className={sector}></div>
                    </div>
                );
            })}
        </motion.div>
    )
}